// removed by extract-text-webpack-plugin
module.exports = {"DefaultLayout":"_2yIgg6NeLNFVK5DvIBNcD8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/layouts/DefaultLayout.scss
// module id = 2938
// module chunks = 0